import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, AppBar, Toolbar, IconButton, Badge } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FilterProperty from '../components/SearchPropert/FilterProperty';
import PropertyCard from '../components/SearchPropert/PropertyCard';
import AdvertisementPage from '../components/SearchPropert/AdvertisementPage';
import FilterListIcon from '@mui/icons-material/FilterList';
import SearchIcon from '@mui/icons-material/Search';
import { Collapse } from "@mui/material";

const SearchPropertyScreen = ({ collapsed }) => {
    const location = useLocation();

    // const { address, city, SelectLocation, type, filteredProperties, keyword: headerKeyword, isAuthenticated, maxSqft, minSqft, maxPrice, minPrice } = location.state || {};
    const state = location.state || {};

    const address = state.address || "";
    const city = state.city || "";
    const type = state.type || "";
    const minPrice = state.minPrice != null ? Number(state.minPrice) : null;
    const maxPrice = state.maxPrice != null ? Number(state.maxPrice) : null;
    const minSqft = state.minSqft != null ? Number(state.minSqft) : null;
    const maxSqft = state.maxSqft != null ? Number(state.maxSqft) : null;
    const filteredProperties = state.filteredProperties || [];
    const isAuthenticated = state.isAuthenticated || false;
    const headerKeyword = state.keyword || "";
    const SelectLocation = state.SelectLocation || "";



  

    let locationInput = `${address || ''}, ${city || ''}`;
    const [keyword, setKeyword] = useState(headerKeyword || '');
    const [isFocused, setIsFocused] = useState(false);
    const theme = useSelector((data) => data.themeValue.colors)
    const [showAd, setShowAd] = useState(true);
    const [filterCount, setFilterCount] = useState(0);
    const [showFilters, setShowFilters] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);


    const [filters, setFilters] = useState({
        priceRange: [0, 100000000],
        minSize: 0,
        maxSize: 10000,
        type: '',
        marketPriceRange: [0, 100000000],
        sizeRange: [0, 10000],
        villaPrice: [50000, 100000000],
        villaMinSize: 100,
        villaMaxSize: 100000,
    });

    const toggleFilters = () => {
        setShowFilters(prev => !prev);
        if (!showFilters) {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };
    useEffect(() => {
        setFilters(prev => ({
            ...prev,
            type,
            marketPriceRange: [
                minPrice ?? prev.marketPriceRange[0],
                maxPrice ?? prev.marketPriceRange[1],
            ],
            sizeRange: [
                minSqft ?? prev.sizeRange[0],
                maxSqft ?? prev.sizeRange[1],
            ],
        }));
    }, []);


    useEffect(() => {
        setFilters((prev) => ({
            ...prev,
            type: type || prev.type,

            // price
            marketPriceRange: [
                minPrice ? Number(minPrice) : prev.marketPriceRange[0],
                maxPrice ? Number(maxPrice) : prev.marketPriceRange[1],
            ],

            // size
            sizeRange: [
                minSqft ? Number(minSqft) : prev.sizeRange[0],
                maxSqft ? Number(maxSqft) : prev.sizeRange[1],
            ],
        }));
    }, [type, minPrice, maxPrice, minSqft, maxSqft]);

    const navigate = useNavigate();

    // Handle search when Enter is pressed
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            // Update the keyword state which will trigger re-render and filtering
            setKeyword(e.target.value);
        }
    };

    // Handle clear search - show all properties when search is empty
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setKeyword(value);

        // If user clears the search, show all properties immediately
        if (value === '') {
            setKeyword('');
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        const handleResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Update keyword when header search is used
    useEffect(() => {
        if (headerKeyword !== undefined) {
            setKeyword(headerKeyword);
        }
    }, [headerKeyword]);

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingTop: '0rem',
                margin: '0 auto',
                fontFamily: 'Segoe UI, sans-serif',
                minHeight: "90vh"
            }}
        >
            {/* Mobile Search Bar */}
            <AppBar
                position="fixed"
                sx={{
                    display: { xs: "flex", sm: "none" },
                    top: { xs: 70, sm: 40 },
                    left: -10,
                    right: 0,
                    width: "102%",
                    backgroundColor: "white",
                    boxShadow: "none",
                    color: theme.text || "#fff",
                    zIndex: 1200,
                    textAlign: "end",
                    justifyContent: "flex-end",
                    marginLeft: { xs: "5px", sm: collapsed ? 10 : 30 },
                    transition: "margin 0.3s ease",
                }}
            >
                <Toolbar sx={{ justifyContent: 'space-between', minHeight: { xs: 60, md: 70 } }}>
                    <Box sx={{ display: 'flex', flex: 1, maxWidth: { xs: '100%', md: 400 }, mr: 2 }}>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search by area, city, property..."
                            value={keyword}
                            onChange={handleSearchChange}
                            onKeyPress={handleKeyPress}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    backgroundColor: '#f5f5f5',
                                    '& fieldset': { borderColor: '#ddd' },
                                    '&:hover fieldset': { borderColor: '#007bff' },
                                    '&.Mui-focused fieldset': { borderColor: '#007bff' },
                                },
                            }}
                            InputProps={{
                                startAdornment: <SearchIcon sx={{ color: '#666', mr: 1 }} />,
                            }}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <IconButton
                            onClick={toggleFilters}
                            sx={{
                                backgroundColor: '#1976d3',
                                color: '#fff',
                                '&:hover': { backgroundColor: theme.secondary || '#0056b3' },
                                borderRadius: '10px',
                                padding: '8px',
                            }}
                        >
                            <Badge badgeContent={filterCount} color="error" invisible={filterCount === 0}>
                                <FilterListIcon />
                            </Badge>
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        md: 'row'
                    },
                    justifyContent: 'space-between',
                    gap: 2,
                    width: '100%',
                    maxWidth: '100%',
                    mt: 1.25,
                }}
            >
                {/* Filter Section */}
                {(isMobile ? showFilters : true) && (
                    <Box
                        sx={{
                            width: {
                                xs: '100%',
                                md: '30%',
                            },
                            mt: {
                                xs: 10,
                                md: 2,
                            },
                        }}
                    >
                        <FilterProperty filters={filters} setFilters={setFilters} />
                    </Box>
                )}

                {/* Property Card Section */}
                <Box
                    sx={{
                        width: {
                            xs: '100%',
                            md: showAd ? '50%' : '65%',
                        },
                        mt: {
                            xs: showFilters ? 0 : 6,
                            md: 0,
                        },
                        transition: 'width 0.3s ease',
                    }}
                >
                    <PropertyCard
                        filters={filters}
                        address={address}
                        city={city}
                        keyword={keyword}
                        initialData={filteredProperties}   // 👈 ADD THIS
                        showAd={showAd}
                        isAuthenticated={isAuthenticated}
                           searchData={state} 
                    />

                </Box>

                {/* Advertisement Section */}
                {showAd && (
                    <Box
                        sx={{
                            display: { xs: "none", md: "block" },
                            width: { md: "15%" },
                            mt: { md: 0 }
                        }}
                    >
                        <AdvertisementPage setShowAd={setShowAd} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default SearchPropertyScreen;